
import { Box, Grid, Typography } from "@mui/material";
import RootComponents from "../../../components/common/RootComponents";
import styles from "../Candidate.module.css";
import { useNavigate } from "react-router-dom";
import consultant_image from '../../../assets/images/Add Candidate Image.png';

const CandidateListingfound = () => {
    const navigate = useNavigate()
    return (
        // <RootComponents>
            <Box className={styles.found_candidate_box}>
                <Box sx={{ display: 'flex', alignItems: 'center',paddingLeft:'20px' }}>
                    <Box>
                        <Typography >
                            <img
                                src={consultant_image}
                                alt=""
                                className={styles.consultant_image}
                            />

                        </Typography>
                        <span>
                            <Typography >
                                {/* <img
                                src={consultant_image}
                                alt=""
                                className={styles.consultant_image}
                            /> */}
                                <b>No candidate found here! </b>
                            </Typography>
                        </span>

                    </Box>


                    <span style={{paddingLeft:'30px', }}>
                        <Typography sx={{ marginBottom: '20px !important', fontSize:'20px !important'}}>
                            {/* <img
                                src={consultant_image}
                                alt=""
                                className={styles.consultant_image}
                            /> */}
                            <b>Never lose the chance of great submission! </b>
                        </Typography>
                        <Box sx={{fontSize:'17px !important'}}>
                        <a >
                            A candidate may mutually associate with many recruiters be unique and make it different.
                        </a>
                        <br></br>
                        <a >
                            Candidate Tracking | Submission Tracking| Track Requirement
                        </a>
                        </Box>
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                            <button onClick={() => navigate('/add-consultant')}>
                                Add Candidate
                            </button>
                        </div>

                    </span>

                </Box>

            </Box>
        // </RootComponents>
    )
}

export default CandidateListingfound;